import _ from 'lodash';

let resizeObserver: any = null;
const cleanup = () => {
  if (resizeObserver) {
    resizeObserver.disconnect();
    resizeObserver = undefined;
  }
};
let func: any = () => {};
export default {
  mounted(el: HTMLElement) {
    let sourceHeight = 0;
    func = (entries: any[]) => {
      const height = entries[0].target.clientHeight;
      if (height === 0) {
        return;
      }
      if (sourceHeight !== 0 && height !== 0) {
        const ratio = height / sourceHeight;
        el.style.height = `${el.clientHeight * ratio - 46 - 36}px`;
      }
      sourceHeight = height;
    };
    resizeObserver = new ResizeObserver(_.debounce(func, 100));
    resizeObserver.observe(el.parentElement as HTMLElement);
  },
  updated(el: HTMLElement) {
    cleanup();
    if (!el?.parentElement) return;
    resizeObserver = new ResizeObserver(_.debounce(func, 100));
    resizeObserver.observe(el.parentElement as HTMLElement);
  },
  unmounted(el: HTMLElement) {
    if (!el?.parentElement) return;
    resizeObserver.unobserve(el.parentElement as HTMLElement);
  },
};
